import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { Container } from "@mui/system";
import SkeletonLoader from "../UI/Skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "../Search/Search.module.css";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { Grid, Stack, Card, Typography, Pagination } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

import {
  getTagData,
  getImplCustomers,
  getImplTags,
  getOrganizationUser,
  getViewsCount,
} from "./Network_Calls";

const Youtube = () => {
  const [select, setSelect] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);
  const [implementations, setImplementations] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [filterdList, setFilteredList] = useState([]);
  const [filterState, setFilterstate] = useState(false);
  const [implTags, setImplTags] = useState([]);
  const [impl_id, setImpl_id] = useState();
  const [view, setView] = useState(false);
  const [most_viewed, setmost_viewd] = useState([]);
  const [uniqueData, setUniqueData] = useState([]);
  const [leastViewData, setLeastViewData] = useState([]);
  const [recommendedData, setRecommendedData] = useState([]);
  const [recentPage, setRecentPage] = useState(1);
  const [leastViewPage, setLeastViewPage] = useState(1);
  const [recommendedPage, setRecommendedPage] = useState(1);
  const [recentRowsPerPage, setRecentRowsPerPage] = useState(6);
  const [leastViewRowsPerPage, setLeastViewRowsPerPage] = useState(6);
  const [recommendedRowsPerPage, setRecommendedRowsPerPage] = useState(6);

  console.log("imp id", impl_id);
  console.log("item name", select);
  console.log("Recent Views", uniqueData);
  console.log("Least Views", leastViewData);
  console.log("Recommended views", recommendedData);

  // Pagination Change Handlers
  const handleRecentPageChange = (event, page) => {
    setRecentPage(page);
  };

  const handleLeastViewPageChange = (event, page) => {
    setLeastViewPage(page);
  };

  const handleRecommendedPageChange = (event, page) => {
    setRecommendedPage(page);
  };

  // Pagination calculations
  const recentOffset = (recentPage - 1) * recentRowsPerPage;
  const leastViewOffset = (leastViewPage - 1) * leastViewRowsPerPage;
  const recommendedOffset = (recommendedPage - 1) * recommendedRowsPerPage;

  const taggingData = async (data, state) => {
    console.log(data);
    // data.id === null && data.tags === "empty"
    if (state) {
      setFilterstate(false);
    } else {
      try {
        // console.log(tagInfo);
        console.log(data.id);
        // const resp = await getTagData(data.id ? data.id : tagInfo);
        const resp = await getTagData(data.id);
        const result = await resp.data;
        // console.log(result, "jjjjj");
        if (result.message === "successfully fetched") {
          const arr = result.list.map((e) => e.customer_id);

          const tagData = customerList.filter((cus) => {
            return arr.includes(cus._id);
          });
          setFilterstate(true);
          // setTagInfo(result.tag_id);
          setFilteredList([...tagData]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const implSelect = async (impl) => {
    setSelect(impl.item_name);
    setImpl_id(impl._id);
    // setImplementationName(impl.item_name);
    if (impl._id) {
      setFilterstate(false);
    }

    try {
      setView(true);
      console.log(impl.item_name);
      const result = await getImplCustomers(impl.item_name);

      if (result.data.msg === "Generated") {
        const views = result.data.views.slice(0, 6);
        setmost_viewd([...views]);
        setCustomerList([...result.data.users]);
        setView(false);
      }
      const response = await getImplTags(impl._id);
      // console.log(response);
      if (response.data.message === "success") {
        setImplTags([...response.data.implTags]);
        setView(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let typeOfJourney =
    select !== ""
      ? implementations.filter((x) => x.item_name === select)
      : [{ usertype: "Customer" }];

  useEffect(() => {
    try {
      (async () => {
        setLoading(true);

        // const result = await getOrganizationUser();

        if (true) {
          setErr(false);
          setLoading(false);
          // setImplementations(result.data.list);

          // setImplementationName(result.data.list[0].item_name);
          // const response = await getImplTags(result.data.list[0]._id);
          // console.log(response);
          // if (response.data.message === "success") {
          //     setImplTags([...response.data.implTags]);
          // }
          setSelect(localStorage.getItem("tagname"));
          setImpl_id(localStorage.getItem("tag_id"));
          const resp = await getImplCustomers(localStorage.getItem("tagname"));
          if (resp.data.msg === "Generated") {
            const views = resp.data.views.slice(0, 6);
            setmost_viewd([...views]);
            setCustomerList([...resp.data.users]);
          }
        } else {
          setErr(true);
        }
      })();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    try {
      (async () => {
        const result = await getViewsCount(select);
        if (result) {
          if ((result.data.status = 200)) {
            //console.log("views count", result.data);
            const { recentViews, leastViewCustomers, recommendedViews } =
              result.data;
            setUniqueData(recentViews);
            setLeastViewData(leastViewCustomers);
            setRecommendedData(recommendedViews);
          }
        } else {
          setErr(true);
        }
      })();
    } catch (error) {
      console.log(error);
    }
  }, [select]);

  return (
    <>
      <Navbar />
      <div style={{ display: "flex" }}>
        <Container>
          <div>
            {/* {loading ? (
                    <>
                        <p className={classes.loader}>
                        <span className={classes.spinner}></span>
                        <span>Loading...</span>
                        </p>
                        <SkeletonLoader />
                    </>
                    ) : implementations.length !== 0 ? (
                    <div className={classes.optionMain}>
                        {implementations.length >= 0 ? (
                            implementations.map((impl, index) => (
                                <div
                                key={index}
                                className={
                                    select === impl.item_name
                                    ? classes.optionCardSelect
                                    : classes.optionCard
                                }
                                onClick={() => implSelect(impl)}
                                >
                                {impl.item_name}
                                </div>
                            ))
                        ) : (
                        <p></p>
                        )}
                    </div>
                    ) : (
                    <div className={classes.noData}>
                        <h4>No data found</h4>
                    </div>
                    )} */}
          </div>
          {!view ? (
            <div>
              <br />
              <div className={classes.search}>
                <h1>
                  <span className={classes.customer}>
                    {/* {typeOfJourney[0].usertype + " " || "-"} */}
                  </span>
                  <span className={classes.journey}>Journey</span>
                </h1>
              </div>

              <div>
                <div>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)",
                    }}
                  >
                    Recently Viewed
                  </Typography>
                  <br />
                  {uniqueData.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                          style={{}}
                        >
                          {uniqueData
                            .slice(
                              recentOffset,
                              recentOffset + recentRowsPerPage
                            )
                            .map((customerData, index) => (
                              // <Link style={{ textDecoration: 'none' }} target="__blanck" to={`/user/findcontact/${localStorage.getItem("tag_id")}/${customerData.customer}?name=${customerData.customer}`}>
                              <Grid item xs={2} sm={4} md={4} key={index}>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to={`/user/findcontact/${localStorage.getItem(
                                    "tag_id"
                                  )}/${customerData._id}?name=${
                                    customerData.username
                                  }`}
                                >
                                  <Card
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "1rem",
                                      width: "23rem",
                                      marginBottom: "2rem",
                                      marginRight: "1rem",
                                      padding: "0.5rem",
                                      outline: "0.1rem solid #00A0B2",
                                    }}
                                  >
                                    <Grid container alignItems="center">
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <AccountCircleOutlinedIcon />
                                      </Grid>
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <Typography
                                          variant="body2"
                                          fontWeight="bold"
                                        >
                                          {customerData.username == ""
                                            ? customerData.customer
                                            : customerData.username}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Grid container alignItems="center">
                                      <Grid
                                        item
                                        sx={{ marginLeft: 1 }}
                                        title={"Interaction Count"}
                                      >
                                        <GroupOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.interaction_count}
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        sx={{ marginLeft: 20 }}
                                        title={"View Count"}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.customer_views}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Link>
                              </Grid>
                              // </Link>
                            ))}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(uniqueData.length / recentRowsPerPage)}
                        page={recentPage}
                        onChange={handleRecentPageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center">
                      Loading...
                    </Typography>
                  )}
                </div>

                <div>
                  <br />
                  <br />
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)",
                    }}
                  >
                    Recommended Views
                  </Typography>
                  {recommendedData.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                          {recommendedData
                            .slice(
                              recommendedOffset,
                              recommendedOffset + recommendedRowsPerPage
                            )
                            .map((customerData, index) => (
                              <Grid item xs={2} sm={4} md={4} key={index}>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to={`/user/findcontact/${localStorage.getItem(
                                    "tag_id"
                                  )}/${customerData.external_id}?name=${
                                    customerData.username
                                  }`}
                                >
                                                                        {/* {JSON.stringify(customerData)} */}

                                  <Card
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "1rem",
                                      width: "23rem",
                                      marginBottom: "2rem",
                                      marginRight: "1rem",
                                      padding: "0.5rem",
                                      outline: "0.1rem solid #00A0B2",
                                    }}
                                  >
                                    <Grid container alignItems="center">
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <AccountCircleOutlinedIcon />
                                      </Grid>
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <Typography
                                          variant="body2"
                                          fontWeight="bold"
                                        >
                                          {customerData.username == ""
                                            ? customerData.customer
                                            : customerData.username}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Grid container alignItems="center">
                                      <Grid
                                        item
                                        sx={{ marginLeft: 1 }}
                                        title={"Interaction Count"}
                                      >
                                        <GroupOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.interaction_count}
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        sx={{ marginLeft: 20 }}
                                        title={"View Count"}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.customer_views}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Link>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(
                          recommendedData.length / recommendedRowsPerPage
                        )}
                        page={recommendedPage}
                        onChange={handleRecommendedPageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center">
                      {/* No records found for Recommended Views.
                       */}
                      Loading...
                    </Typography>
                  )}
                </div>
                <div>
                  <br />
                  <br />
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)",
                    }}
                  >
                    Least Viewed
                  </Typography>
                  {leastViewData.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                          {leastViewData
                            .slice(
                              leastViewOffset,
                              leastViewOffset + leastViewRowsPerPage
                            )
                            .map((customerData, index) => (
                              <Grid item xs={2} sm={4} md={4} key={index}>
                                 <Link
                                  style={{ textDecoration: "none" }}
                                  to={`/user/findcontact/${localStorage.getItem(
                                    "tag_id"
                                  )}/${customerData.external_id}?name=${
                                    customerData.username
                                  }`}
                                >
                                  <Card
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "1rem",
                                      width: "23rem",
                                      marginBottom: "2rem",
                                      marginRight: "1rem",
                                      padding: "0.5rem",
                                      outline: "0.1rem solid #00A0B2",
                                    }}
                                  >
                                    <Grid container alignItems="center">
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <AccountCircleOutlinedIcon />
                                      </Grid>
                                      <Grid item sx={{ marginLeft: 1 }}>
                                        <Typography
                                          variant="body2"
                                          fontWeight="bold"
                                        >
                                          {customerData.username == ""
                                            ? customerData.customer
                                            : customerData.username}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Grid container alignItems="center">
                                      <Grid
                                        item
                                        sx={{ marginLeft: 1 }}
                                        title={"Interaction Count"}
                                      >
                                        <GroupOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.interaction_count}
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        sx={{ marginLeft: 20 }}
                                        title={"View Count"}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </Grid>
                                      <Grid item>
                                        <Typography
                                          sx={{ marginLeft: "0.5rem" }}
                                          variant="body2"
                                        >
                                          {customerData.customer_views}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Link>
                              </Grid>
                            ))}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(
                          leastViewData.length / leastViewRowsPerPage
                        )}
                        page={leastViewPage}
                        onChange={handleLeastViewPageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center">
                      {/* No records found for Least Views. */}
                      Loading...
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "80px",
              }}
            >
              <div sx={{ display: "flex" }}>
                <CircularProgress />
              </div>
              <p>Loading</p>
            </div>
          )}
        </Container>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "80px",
        }}
      >
        <Footer />
      </div>
    </>
  );
};

export default Youtube;